// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"2226dfbe","832":"26d3bce2"}[chunkId] + ".chunk.js";
};